import { CleaveOptions } from 'cleave.js/options';

export const getPhoneCodeFormatter = () =>
  ({
    delimiter: '+',
    blocks: [0, 3],
    numericOnly: true,
  } as CleaveOptions);

export const getPhoneNumberFormatter = (isUK: boolean) => {
  const blocks = isUK ? [0, 2, 0, 4, 7] : [0, 3, 0, 3, 4]
  return ({
    delimiters: ['(', ')', ' ', '-'],
    blocks,
    numericOnly: true,
  } as CleaveOptions);
}
